/**
 * @fileoverview gRPC-Web generated client stub for sso
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: api/dashboard/v2/sso_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.sso = require('./sso_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.sso.SsoServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.sso.SsoServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.sso.SSOUrlRequest,
 *   !proto.sso.SSOUrlResponse>}
 */
const methodDescriptor_SsoService_GetSSOUrl = new grpc.web.MethodDescriptor(
  '/sso.SsoService/GetSSOUrl',
  grpc.web.MethodType.UNARY,
  proto.sso.SSOUrlRequest,
  proto.sso.SSOUrlResponse,
  /**
   * @param {!proto.sso.SSOUrlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.sso.SSOUrlResponse.deserializeBinary
);


/**
 * @param {!proto.sso.SSOUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.sso.SSOUrlResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.sso.SSOUrlResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.sso.SsoServiceClient.prototype.getSSOUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/sso.SsoService/GetSSOUrl',
      request,
      metadata || {},
      methodDescriptor_SsoService_GetSSOUrl,
      callback);
};


/**
 * @param {!proto.sso.SSOUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.sso.SSOUrlResponse>}
 *     Promise that resolves to the response
 */
proto.sso.SsoServicePromiseClient.prototype.getSSOUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/sso.SsoService/GetSSOUrl',
      request,
      metadata || {},
      methodDescriptor_SsoService_GetSSOUrl);
};


module.exports = proto.sso;

